/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_Webrtc_UnsupportedInputs */

const vi_vehicle_camera_webrtc_unsupported = /** @type {(inputs: Vehicle_Camera_Webrtc_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt không hỗ trợ WebRTC`)
};

/**

* @param {Vehicle_Camera_Webrtc_UnsupportedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_webrtc_unsupported = /** @type {((inputs?: Vehicle_Camera_Webrtc_UnsupportedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_Webrtc_UnsupportedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_webrtc_unsupported(inputs)
});